module.exports = __webpack_public_path__ + "img/Fylkeskommuner - Akershus.d8418eaf.svg";